// extracted by extract-css-chunks-webpack-plugin
module.exports = {"supported-label":"card-payment-method__supported-label___14RZp","supportedLabel":"card-payment-method__supported-label___14RZp","col-zipcode":"card-payment-method__col-zipcode___sSfxb","colZipcode":"card-payment-method__col-zipcode___sSfxb","supported-cards-wrapper":"card-payment-method__supported-cards-wrapper___2f0Z8","supportedCardsWrapper":"card-payment-method__supported-cards-wrapper___2f0Z8"};
    if(module.hot) {
      // 1790321826020
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  